import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "@/lib/api";
import { Input } from "@/components/ui/input";

const sel = "h-10 w-full rounded-md border border-white/10 bg-[#07090E] px-3 text-sm";

export const BattlesAdmin = () => {
  const [tracks, setTracks] = useState([]);
  const [list, setList] = useState([]);
  const [f, setF] = useState({ track_a: "", track_b: "", days: 7, title: "" });
  const load = () => api.get("/admin/battles").then((r) => setList(r.data));
  useEffect(() => { load(); api.get("/admin/tracks", { params: { status: "approved" } }).then((r) => setTracks(r.data.filter((t) => t.artist_status === "approved"))); }, []);
  const create = async (e) => {
    e.preventDefault();
    try { await api.post("/admin/battles", { ...f, days: +f.days, title: f.title || null }); toast.success("Battle started — both artists were emailed"); load(); } catch (er) { toast.error(errMsg(er)); }
  };
  const opt = tracks.map((t) => <option key={t.id} value={t.id}>{t.artist_name} — {t.title}</option>);
  return (
    <div className="space-y-6" data-testid="admin-battles">
      <form onSubmit={create} className="panel grid gap-3 p-6 md:grid-cols-5" data-testid="battle-form">
        <select required value={f.track_a} onChange={(e) => setF({ ...f, track_a: e.target.value })} className={`${sel} md:col-span-2`} data-testid="battle-track-a"><option value="">Track A…</option>{opt}</select>
        <select required value={f.track_b} onChange={(e) => setF({ ...f, track_b: e.target.value })} className={`${sel} md:col-span-2`} data-testid="battle-track-b"><option value="">Track B…</option>{opt}</select>
        <Input type="number" min={1} max={31} value={f.days} onChange={(e) => setF({ ...f, days: e.target.value })} className="border-white/10 bg-[#07090E]" data-testid="battle-days" />
        <Input placeholder="Title (optional)" value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} className="border-white/10 bg-[#07090E] md:col-span-4" data-testid="battle-title" />
        <button className="btn-hot !py-2" data-testid="battle-create-button">Start battle</button>
      </form>
      <p className="text-xs text-slate-500">Starting a new battle closes the current one. On the 1st of each month a battle starts automatically between the two most-flamed tracks of the last 30 days (if none is running).</p>
      {list.map((b) => (
        <div key={b.id} className="panel flex flex-wrap items-center justify-between gap-3 p-5" data-testid={`admin-battle-${b.id}`}>
          <div><div className="font-display text-lg font-bold">{b.a?.artist.stage_name} vs {b.b?.artist.stage_name}</div><div className="font-mono text-xs text-slate-500">{b.title} · {fmtDate(b.start)} → {fmtDate(b.end)}</div></div>
          <span className={`font-mono text-sm ${b.status === "active" ? "text-[#FF2E63]" : "text-slate-400"}`}>{b.votes.a}–{b.votes.b} · {b.status === "active" ? "LIVE" : `winner ${b.winner ? b[b.winner]?.artist.stage_name : "tie"}`}</span>
        </div>
      ))}
    </div>
  );
};

export const BookingsAdmin = () => {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/admin/bookings").then((r) => setList(r.data)); }, []);
  return (
    <div className="space-y-3" data-testid="admin-bookings">
      {list.map((b) => (
        <div key={b.id} className="panel p-4 text-sm">
          <div className="flex flex-wrap justify-between gap-2"><span className="font-display font-bold">{b.artist_name} ← {b.name}{b.organization && ` (${b.organization})`}</span><span className="font-mono text-xs uppercase text-slate-500">{b.status} · {fmtDate(b.created_at)}</span></div>
          <div className="mt-1 text-xs text-slate-500">{b.email} · {b.city} · {b.event_date} {b.budget && `· ${b.budget}`}</div>
          <p className="mt-2 line-clamp-2 text-slate-400">{b.message}</p>
        </div>
      ))}
      {!list.length && <p className="text-slate-500">No booking requests yet.</p>}
    </div>
  );
};
